import React, { useState, useEffect, useCallback } from 'react'
import {Form} from 'react-bootstrap'
import Header from '../Component/Header';
import PageHead from '../Component/pageHead';
import Footer from '../Component/footer';
import {PostAction} from '../Component/PostAction';
import {useFormik} from 'formik';
import { useHistory } from 'react-router-dom';
import {GetAction} from '../Component/GetAction'

function sessionVal(key) {
  const raw = sessionStorage.getItem(key)
  if (raw == null || raw === 'null' || raw === 'undefined') return ''
  return raw
}

function mapUserToForm(user = {}) {
  return {
    id: user.id != null ? String(user.id) : '',
    firstName: user.first_name ?? user.firstName ?? '',
    lastName: user.last_name ?? user.lastName ?? '',
    email: user.email_address ?? user.email ?? '',
    mobile: user.mobile != null ? String(user.mobile) : '',
    adharCard: user.adhar_card ?? user.adharCard ?? '',
    panNumber: user.pan_number ?? user.panNumber ?? '',
    address1: user.address1 ?? user.address_1 ?? '',
    address2: user.address2 ?? user.address_2 ?? '',
    city: user.city ?? '',
    country_id: user.country_id != null ? String(user.country_id) : '',
    country_name: user.country_name ?? '',
    state: user.state != null ? String(user.state) : '',
    state_name: user.state_name ?? '',
    zip_no: user.zip_no != null ? String(user.zip_no) : '',
  }
}

function formFromSession() {
  return mapUserToForm({
    id: sessionVal('id'),
    first_name: sessionVal('first_name'),
    last_name: sessionVal('last_name'),
    email_address: sessionVal('email_address') || sessionVal('email'),
    mobile: sessionVal('mobile'),
    adhar_card: sessionVal('adhar_card'),
    pan_number: sessionVal('pan_number'),
    address1: sessionVal('address1'),
    address2: sessionVal('address2'),
    city: sessionVal('city'),
    country_id: sessionVal('country_id'),
    country_name: sessionVal('country_name'),
    state: sessionVal('state'),
    state_name: sessionVal('state_name') || sessionVal('state'),
    zip_no: sessionVal('zip_no'),
  })
}

function syncSessionFromForm(values) {
  const pairs = {
    id: values.id,
    first_name: values.firstName,
    last_name: values.lastName,
    email_address: values.email,
    email: values.email,
    mobile: values.mobile,
    adhar_card: values.adharCard,
    pan_number: values.panNumber,
    address1: values.address1,
    address2: values.address2,
    city: values.city,
    country_id: values.country_id,
    country_name: values.country_name,
    state: values.state,
    state_name: values.state_name,
    zip_no: values.zip_no,
    name: `${values.firstName || ''} ${values.lastName || ''}`.trim(),
  }
  Object.entries(pairs).forEach(([key, value]) => {
    sessionStorage.setItem(key, value != null ? String(value) : '')
  })
}

function Profile() {
    const [formData, setFormData] = useState(formFromSession);
    const [counrtyData, setCountryData] = useState([]);
    const [listData, setListData] = useState([]);
    const [countryId, setCountryId] = useState(() => formFromSession().country_id);
    const [loading, setLoading] = useState(true);
    const postUrl = 'user/updateProfile'
    const history = useHistory()

    useEffect(() => {
      if (!sessionStorage.getItem('id')) {
        history.push('/Login')
      }
    }, [history])

    const applyUser = useCallback((user) => {
      const mapped = mapUserToForm(user)
      setFormData(mapped)
      setCountryId(mapped.country_id || '')
      syncSessionFromForm(mapped)
    }, [])

    useEffect(() => {
      const userId = sessionStorage.getItem('id')
      if (!userId) {
        setLoading(false)
        return
      }

      const loadProfile = async () => {
        setLoading(true)
        try {
          const res = await PostAction('post', { id: userId }, 'user/userDetails')
          const user = res?.response
          if (res?.status === 'success' && user && typeof user === 'object') {
            applyUser(user)
          } else {
            // Fall back to session (read at mount time, not module load)
            setFormData(formFromSession())
            setCountryId(formFromSession().country_id || '')
          }
        } catch (e) {
          setFormData(formFromSession())
          setCountryId(formFromSession().country_id || '')
        } finally {
          setLoading(false)
        }
      }

      loadProfile()
    }, [applyUser])

    useEffect(() => {
      const callCountryAPI = async () => {
        const res = await GetAction('get', {}, 'Master/countryList')
        setCountryData(Array.isArray(res?.response) ? res.response : [])
      }
      callCountryAPI()
    }, [])

    const callStateAPI = useCallback(async (id) => {
      if (!id) {
        setListData([])
        return
      }
      const res = await GetAction('get', { country_id: id }, 'Master/stateList')
      setListData(Array.isArray(res?.response) ? res.response : [])
    }, [])

    useEffect(() => {
      callStateAPI(countryId)
    }, [countryId, callStateAPI])

    const {values, handleChange, handleSubmit, setFieldValue} = useFormik({
        initialValues: formData,
        enableReinitialize: true,
        onSubmit: (values) => {
          const callPOSTAPI = async () => {
            const payload = {
              id: values.id,
              actor_id: values.id,
              first_name: values.firstName,
              last_name: values.lastName,
              email_address: values.email,
              mobile: values.mobile,
              adhar_card: values.adharCard,
              pan_number: values.panNumber,
              address1: values.address1,
              address2: values.address2,
              city: values.city,
              country_id: values.country_id,
              country_name: values.country_name,
              state: values.state,
              state_name: values.state_name,
              zip_no: values.zip_no,
            }
            const res = await PostAction('post', payload, postUrl)
            if (res?.status === 'success') {
              syncSessionFromForm(values)
            }
            alert(res?.message || (res?.status === 'success' ? 'Profile updated.' : 'Update failed.'))
          }
          callPOSTAPI()
        }
      })

    const handleCountry = (event) => {
      const id = event.target.value
      const name = event.target[event.target.selectedIndex]?.getAttribute('data-name') || ''
      setCountryId(id)
      setFieldValue('country_id', id)
      setFieldValue('country_name', name)
      setFieldValue('state', '')
      setFieldValue('state_name', '')
    }

    const changeState = (event) => {
      const id = event.target.value
      const name = event.target[event.target.selectedIndex]?.getAttribute('data-name') || ''
      setFieldValue('state', id)
      setFieldValue('state_name', name)
    }

  return (
    <>
     <Header /> 
     <PageHead title="Profile" />
     <section className="profile-page">
        <div className="container">
          <div className="profile-card">
            <div className="profile-card-header">
              <h2 className="profile-card-title">Member details</h2>
              <p className="profile-card-subtitle">Keep your contact and address information up to date.</p>
            </div>
            {loading ? (
              <p className="text-muted mb-0">Loading your profile…</p>
            ) : (
            <Form onSubmit={handleSubmit} className="profile-form">
                <div className="row">
                    <div className="col-12 col-md-6 mb-3">
                        <label className="form-label" htmlFor="firstName">First Name</label>
                        <input
                        className="form-control"
                        type="text"
                        id="firstName"
                        name="firstName"
                        value={values.firstName || ''}
                        onChange={handleChange}
                        />
                    </div>
                    <div className="col-12 col-md-6 mb-3">
                        <label className="form-label" htmlFor="lastName">Last Name</label>
                        <input
                        className="form-control"
                        type="text"
                        id="lastName"
                        name="lastName"
                        value={values.lastName || ''}
                        onChange={handleChange}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 col-md-6 mb-3">
                        <label className="form-label" htmlFor="email">Email</label>
                        <input
                        type="email"
                        className="form-control"
                        name="email"
                        id="email"
                        value={values.email || ''}
                        onChange={handleChange}
                        />
                    </div>
                    <div className="col-12 col-md-6 mb-3">
                        <label className="form-label" htmlFor="mobile">Mobile</label>
                        <input
                        type="text"
                        inputMode="numeric"
                        className="form-control"
                        name="mobile"
                        id="mobile"
                        value={values.mobile || ''}
                        onChange={handleChange}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 col-md-6 mb-3">
                        <label className="form-label" htmlFor="adharCard">
                          Aadhaar Card Number <span className="text-muted">(Optional)</span>
                        </label>
                        <input
                        type="text"
                        className="form-control"
                        name="adharCard"
                        id="adharCard"
                        value={values.adharCard || ''}
                        onChange={handleChange}
                        />
                    </div>
                    <div className="col-12 col-md-6 mb-3">
                        <label className="form-label" htmlFor="panNumber">
                          PAN Number <span className="text-muted">(Optional)</span>
                        </label>
                        <input
                        type="text"
                        className="form-control"
                        name="panNumber"
                        id="panNumber"
                        value={values.panNumber || ''}
                        onChange={handleChange}
                        />
                    </div>
                </div>
                <div className="mb-3">
                    <label className="form-label" htmlFor="address1">Address</label>
                    <input
                    type="text"
                    className="form-control"
                    name="address1"
                    id="address1"
                    value={values.address1 || ''}
                    onChange={handleChange}
                    />
                </div>
                <div className="row">
                    <div className="col-12 col-md-6 mb-3">
                        <label className="form-label" htmlFor="address2">Address 2 <span className="text-muted">(Optional)</span></label>
                        <input
                        type="text"
                        className="form-control"
                        id="address2"
                        name="address2"
                        value={values.address2 || ''}
                        onChange={handleChange}
                        />
                    </div>
                    <div className="col-12 col-md-6 mb-3">
                        <label className="form-label" htmlFor="city">City</label>
                        <input
                        type="text"
                        className="form-control"
                        name="city"
                        id="city"
                        value={values.city || ''}
                        onChange={handleChange}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 col-md-5 mb-3">
                        <label className="form-label" htmlFor="country">Country</label>
                        <select
                        className="form-control custom-select d-block w-100"
                        id="country"
                        name="country_id"
                        onChange={handleCountry}
                        value={values.country_id || ''}>
                            <option value="">Select country</option>
                            {counrtyData.map((country,index)=>
                            <option key={index} value={country.country_id} data-name={country.name}>{country.name}</option>
                            )}
                        </select>
                    </div>
                    <div className="col-12 col-md-4 mb-3">
                        <label className="form-label" htmlFor="state">State</label>
                        <select
                        className="form-control custom-select d-block w-100"
                        id="state"
                        name="state"
                        onChange={changeState}
                        value={values.state || ''}>
                            <option value="">Select state</option>
                            {listData.map((state,index)=>
                            <option key={index} value={state.zone_id} data-name={state.name}>{state.name}</option>
                            )}
                        </select>
                    </div>
                    <div className="col-12 col-md-3 mb-3">
                        <label className="form-label" htmlFor="zip">Zip</label>
                        <input
                        type="text"
                        className="form-control"
                        name="zip_no"
                        id="zip"
                        value={values.zip_no || ''}
                        onChange={handleChange}
                        />
                    </div>
                </div>
                <div className="profile-actions">
                    <button className="btn profile-submit-btn" type="submit">Update Profile</button>
                </div>
            </Form>
            )}
          </div>
        </div>
     </section>
     <Footer /> 
    </>
  )
}

export default Profile
